import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiTrendingUp, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import UpsellSummaryView from './UpsellSummaryView';
import UpsellIndicatorHistory from './UpsellIndicatorHistory';
import '../commissionscan/CommissionScan.css';
const UpsellIndicatorPage: React.FC = () => {
    const navigate = useNavigate();
    const [view, setView] = useState<'summary' | 'history'>('summary');
    return (<div className="cs-page">
      <div className="cs-sidebar">
        <button className="cs-back-link" onClick={() => navigate(ROUTES.MARKETPLACE)}>
          <FiChevronLeft size={14}/>
          Back to Marketplace
        </button>
        <nav className="cs-nav">
          <button className={`cs-nav__item${view === 'summary' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('summary')}>
            <FiTrendingUp size={15}/>
            Upsell Summary
          </button>
          <button className={`cs-nav__item${view === 'history' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('history')}>
            <FiClock size={15}/>
            History
          </button>
        </nav>
      </div>

      <div className={`cs-main${view === 'history' ? ' cs-main--history' : ''}`}>
        {view === 'history' ? (<UpsellIndicatorHistory />) : (<UpsellSummaryView />)}
      </div>
    </div>);
};
export default UpsellIndicatorPage;
